import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { DealPipelineView } from '@/components/views/DealPipelineView';

export const EndorsementsPage = () => {

	return (<AuthenticatedPageLayout>
		<DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_ENDORSEMENTS} />
	</AuthenticatedPageLayout>);
};